import { useQuery } from '@tanstack/react-query';

import { getUserAccessAndRoleFullProfile } from '@helpers/getUserAccessAndRoleFullProfile';

import { apiClient } from '@services/apiClient';

export const userKey = (userId) => ['user', userId];
export const userFn = ({ queryKey }) => apiClient.get(`${APP_SSO_URL}api/user/get-self-user/${queryKey[1]}`);

const userRoleName = {
  Viewer: 'dashboardViewer',
  Editor: 'dashboardEditor',
  Manager: 'dashboardManager',
  Administrator: 'dashboardAdmin',
};

export const useUserQuery = ({ userId }) => {
  return useQuery({
    queryKey: userKey(userId),
    queryFn: userFn,
    enabled: !!userId,
    select: ({ data }) => {
      const currentUser = data.user;
      const userAccessAndRole = getUserAccessAndRoleFullProfile(currentUser.dashboard_access.permissions);
      const role = currentUser.roles.find((role) => role.group === 'ww2-dashboard');

      const userRole = role?.name || userRoleName[userAccessAndRole.userRole];
      const viewSensorDataPermission = userAccessAndRole.userAccess['manageSensorData'];

      return {
        user: currentUser,
        userRole,
        viewSensorDataPermission,
      };
    },
  });
};
